import React, { FC } from 'react';

import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import useUserCountry from '~/hooks/useUserCountry';
import { ProjectBehaviorStrategy } from '~/projects/ProjectBehaviorStrategy';
import { Typographies } from '~/theme/typography';

import styles from './styles.module.scss';

const Agreement: FC = () => {
  const { t } = useTranslation('subscription');
  const countryCode = useUserCountry('');

  return (
    <div className={styles.agreement}>
      <Typography
        className={styles.text}
        variant={Typographies.BODY_SMALL}
        component="p"
      >
        {t('general:payment_processed_by', 'The payment processed by')}{' '}
        {ProjectBehaviorStrategy.getPaymentConfigByCountry(
          countryCode,
        ).getCompanyAddress(t)}
      </Typography>
    </div>
  );
};

export default Agreement;
